//GeneratorFlag:[NoChange]
import Process from './process';

export default {Process}
export{Process}